import axiosInstance from './axiosInstance';

const getPaymentDetails = (paymentId) =>
  axiosInstance.get(`/internal/admin/payments/${paymentId}`);

export default getPaymentDetails;
